import { LL_EXTENDED_SEEK_CHANNELS, USE_LL_EXTENDED_SEEK } from '~/utils/env';

/** Returns a POSIX timestamp in seconds only for enabled live channels. */
export function getCatchUpStart(
  isLive: boolean,
  channelId: string,
  start: unknown,
): number | undefined {
  if (
    !isLive ||
    !USE_LL_EXTENDED_SEEK ||
    !(
      LL_EXTENDED_SEEK_CHANNELS.has('allChannels') ||
      LL_EXTENDED_SEEK_CHANNELS.has(String(channelId))
    ) ||
    typeof start !== 'number' ||
    !Number.isFinite(start) ||
    start <= 0 ||
    start > Date.now() / 1000
  ) {
    return undefined;
  }

  return Math.trunc(start);
}
